export default __webpack_public_path__ + "static/Unbenannt-3-e5dc229caf30b1a83eb27870e727aa94.jpg";